import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { PushData } from '../push-data';
import { PushService } from '../push.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ModalComponent } from '@styleguide/modal/modal/modal.component';
import { ModalHeaderComponent } from '@styleguide/modal/modal-header/modal-header.component';
import { ModalContentComponent } from '@styleguide/modal/modal-content/modal-content.component';
import { ModalFooterComponent } from '@styleguide/modal/modal-footer/modal-footer.component';
import { AsyncPipe } from '@angular/common';
import { take } from 'rxjs/operators';

@Component({
  selector: 'kgr-foreground-push-message',
  templateUrl: './foreground-push-message.component.html',
  styleUrls: ['./foreground-push-message.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalComponent, ModalHeaderComponent, ModalContentComponent, ModalFooterComponent, AsyncPipe],
})
export class ForegroundPushMessageComponent implements OnInit {
  data$ = new BehaviorSubject<PushData | null>(null);

  constructor(
    private pushService: PushService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.pushService.foregroundMessage$.subscribe((data) => {
      console.log('push foreground component display data', data);
      this.data$.next(data);
    });
  }

  reset() {
    this.data$.next(null);
  }

  onOpenClick(data: PushData) {
    this.router.navigate(['/institution', data.institutionId], { queryParams: { target: data.appRoute } });
    this.pushService.clearApplicationIconBadge().pipe(take(1)).subscribe();
    this.data$.next(null);
  }
}
